import { Component, inject, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { BaryInputNumberComponent, BaryInputSelectComponent, BaryInputTextComponent } from '../../../../shared/components';
import { ObjLabelValue } from '../../../../../models/obj-label-value.interface';
import { LIST_CLASSIC_VEHICLE_TYPE, LIST_FRIGO_VEHICLE_TYPE, LIST_MEASURE_UNIT, LIST_VEHICLE_CATEGORY, MeasureUnit, MeasureUnitEnum } from '../../../../../models/vehicle.model';
import { CardsTypeSelector } from '../../../../../models/cards-type-selector';
import { LIST_HANDLING_TYPE } from '../../../../../models/handling-type.model';
import { HandlingTypeEnum } from '../../../../../models/enums/handling-type.enum';
import { CommonModule } from '@angular/common';
import { IconsModule, MDBBootstrapModulesPro } from 'ng-uikit-pro-standard';
import { TransportFormGroup } from '../../../../../models/forms/TransportFormGroup';

@Component({
  selector: 'jhi-transport-estimation-step',
  standalone: true,
  imports: [CommonModule, TranslateModule, BaryInputSelectComponent, BaryInputTextComponent, BaryInputNumberComponent, ReactiveFormsModule, IconsModule, MDBBootstrapModulesPro],
  styleUrls: ['./transport-estimation-step.component.scss'],
  templateUrl: './transport-estimation-step.component.html',
})
export class TransportEstimationStepComponent implements OnInit {
  readonly #translateService = inject(TranslateService);

  @Input() transportFormGroup!: TransportFormGroup;
  @Input() formGroup!: FormGroup;
  @Input() dimensionOpts: { label: string; value: any }[] = []; // "value" est de type number, c'est l'id de la dimension
  @Input() handlingTypes: Array<ObjLabelValue> = [];

  public categories: Array<ObjLabelValue> = Object.values(LIST_VEHICLE_CATEGORY).map(v => ({
    label: this.#translateService.instant(v.labelKey),
    value: v.code,
  }));

  public types!: Array<ObjLabelValue>;

  public weightUnit: Array<MeasureUnit> = [LIST_MEASURE_UNIT[MeasureUnitEnum.KG]];
  public lengthUnit: Array<MeasureUnit> = [LIST_MEASURE_UNIT[MeasureUnitEnum.CENTIMETER]];
  public showSelect = true;

  public readonly CRATE_OF_WINE = HandlingTypeEnum.CRATE_OF_WINE;

  public ngOnInit(): void {
    this.types = (this.transportFormGroup.controls.isControlledTemperature.value ? LIST_FRIGO_VEHICLE_TYPE : LIST_CLASSIC_VEHICLE_TYPE).map(v => ({
      label: this.#translateService.instant(v.labelKey),
      value: v.code,
    }));
    // Permet de forcer la mise à jour du label pour le choix des dimensions, mais pas très propre
    this.formGroup.controls['handlingType'].valueChanges.subscribe(_ => {
      this.showSelect = false;
      setTimeout(() => {
        this.showSelect = true;
      }, 1);
    });
  }

  public getControl(name: string) {
    return this.formGroup.get(name) as FormControl;
  }

  public get isFTL(): boolean {
    return CardsTypeSelector.FTL.value === this.transportFormGroup.controls.serviceType.value;
  }

  public getLabelKeyDimension(): string | null {
    return this.getControl('handlingType')?.value ? LIST_HANDLING_TYPE[this.getControl('handlingType')?.value]?.labelKeyDimension || null : null;
  }

  public getPlaceHolderKeyDimension(): string | null {
    return this.getControl('handlingType')?.value ? LIST_HANDLING_TYPE[this.getControl('handlingType')?.value]?.placeholderKeyDimension || null : null;
  }
}
